import React, { useEffect, useState } from "react";
import { Box, Button, Tooltip } from "@mui/material";
import styles from "./Integrations.module.css";
import ozonetel from "./Assets/ozonetel.svg";
import { useNavigate } from "react-router-dom";
import nurturePay from "./Assets/nurturePay.svg";
import { useAuthUser } from "react-auth-kit";
import zapierLogo from "./Assets/zapierFav.svg";
import { useSelector } from "react-redux";
import getAccessStatus from "../../../../components/RolePermissionAccess/RolePermissionAccess";
import metaLogo from "../../../../assets/images/meta-logo.svg";
import redIicon from "../../../../assets/images/red-i-icon.svg";
import edufinLogo from "../../../../assets/images/edufin.svg";
import { useDispatch } from "react-redux";
import { connectEdufin, getEdufinData } from "../service/IntegrationsSlice";
import { GetEdufinData } from "../service/integrations.request";
import Voxbay from "../../../../assets/images/Voxbay.svg";
import VoxbayLogo from "../../../../assets/images/Vox.png";

export default function Integrations(props: any) {
  const { GetAppsByInstitute, appsList } = props;
  const dispatch = useDispatch();
  const { edufinData } = useSelector((state: any) => state.appIntegrations);
  const auth = useAuthUser();
  const authUser = auth();
  const navigate = useNavigate();
  const { userById } = useSelector((state: any) => state.userDetails);
  const [edufinDataState, setEdufinDataState] = useState<any>(null);

  const instituteDetails = authUser?.institute?.[0]?.instituteDetails;

  const instituteFromLocal = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );

  const hasOzonetel =
    instituteFromLocal &&
    Array?.isArray(instituteFromLocal?.integrationsOpted) &&
    instituteFromLocal?.integrationsOpted?.includes("OZONETEL");

  const hasZapier =
    instituteFromLocal &&
    Array?.isArray(instituteFromLocal?.integrationsOpted) &&
    instituteFromLocal?.integrationsOpted?.includes("ZAPIER");

  const hasMeta =
    instituteFromLocal &&
    Array?.isArray(instituteFromLocal?.integrationsOpted) &&
    instituteFromLocal?.integrationsOpted?.includes("META");

  const hasEdufin =
    instituteFromLocal &&
    Array?.isArray(instituteFromLocal?.integrationsOpted) &&
    instituteFromLocal?.integrationsOpted?.includes("EDUFIN_LOAN");

  const integrationPermissions = userById?.rolePermission?.find(
    (item: any) => item.roleDomainName === "Integrations"
  );

  const hasVoxbay =
    instituteFromLocal &&
    Array?.isArray(instituteFromLocal?.integrationsOpted) &&
    instituteFromLocal?.integrationsOpted?.includes("VOXBAY");

  const nurturePayApp = appsList?.find(
    (app: any) => app.appName === "NURTURE_PAY_EASEBUZZ"
  );
  const metaApp = appsList?.find((app: any) => app.appName === "META");
  const voxbayApp = appsList?.find((app: any) => app.appName === "VOXBAY");
  const [isVoxbayConfigured, setIsVoxbayConfigured] = useState(false);

  useEffect(() => {
    if (voxbayApp) {
      GetAppsByInstitute(instituteDetails?.id);
    }
  }, [voxbayApp]);

  const integrationItems = [
    {
      id: "1",
      logo: nurturePay,
      name: "Nurture Pay",
      description:
        "nurturePay provides a smooth and hassle-free online payment process, ensuring data security and reducing the risk of fraud.",
      btnText: "Setup Now",
      btnUrl: "/app/Integrations/NurturePayDetails",
    },
    {
      id: "2",
      logo: ozonetel,
      name: "Ozonetel",
      description:
        "Integrate Ozonetel's cloud communication solutions into nurture to elevate lead engagement, leveraging call center tools.",
      btnText: hasOzonetel ? "View" : "Setup Now",
      btnUrl: hasOzonetel
        ? "/app/Integrations/OzonetelStages"
        : "/app/Integrations/OzonetelDetails",
    },
    {
      id: "3",
      logo: zapierLogo,
      name: "Zapier",
      description:
        "Zapier is essential for streamlining workflows through automation and integration. By connecting various web applications and...",
      btnText: hasZapier ? "View" : "Setup Now",
      btnUrl: hasZapier
        ? "/app/Integrations/ZapierIntegration"
        : "/app/Integrations/ZapierDetails",
    },
    {
      id: "4",
      logo: metaLogo,
      name: "Meta",
      description:
        "The Meta integration enables seamless connectivity between our platform and Meta’s suite of services, including Facebook and Instagram.",
      btnText: hasMeta ? "View" : "Setup Now",
      btnUrl: "/app/Integrations/MetaIntegration",
    },
    // {
    //   id: "5",
    //   logo: edufinLogo,
    //   name: "Educational Loans",
    //   description:
    //     "Easily enable education loans for your students by completing your institute's profile. This feature connects your institute with verified lenders, streamlines loan processing, and helps students access financial support faster.",
    //   btnText: hasEdufin ? "View" : "Let's start",
    //   btnUrl:
    //     edufinDataState?.length > 0
    //       ? "/app/Integrations/EdufinDetails/EdufinDetailsForDraftState"
    //       : "/app/Integrations/EdufinDetails",
    // },
    {
      id: "5",
      logo: VoxbayLogo,
      name: "VoxBay",
      description:
        "Integrate Voxbay's cloud communication solutions into nurture to elevate lead engagement, leveraging call center tools.",
      btnText: voxbayApp ? "View" : "Setup Now",
      btnUrl: "/app/Integrations/VoxbayDetails",
    },
  ];

  React.useEffect(() => {
    if (instituteDetails) {
      GetAppsByInstitute(instituteDetails?.id);
      const body = {
        instituteId: instituteDetails?.id,
      };
      dispatch<any>(getEdufinData(body));
    }
  }, [GetAppsByInstitute]);

  useEffect(() => {
    if (edufinData) {
      setEdufinDataState(edufinData);
    }
  }, [edufinData]);

  return (
    <Box
      sx={{
        overflow: "auto",
        padding: "14px 16px",
        background: "#EEEEEE",
        maxHeight: "calc(100vh - 65px)",
        position: "relative",
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          background: "#fff",
          border: "1px solid #E9E9E9",
          borderRadius: "8px",
          minHeight: "calc(100vh - 94px)",
        }}
      >
        <Box sx={{ padding: "30px" }}>
          <div className={styles.integrationHead}>Integrations</div>
          <div className={styles.integrationItemsWrapper}>
            {integrationItems?.map((item: any, index: any) => (
              <div className={styles.integrationItemWrap} key={index}>
                {/* {(item?.name === "Meta" ||
                  item?.name === "Educational Loans") && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Tooltip
                      arrow
                      title={
                        item?.name === "Educational Loans"
                          ? "This is early preview access to the Edufin Loans."
                          : "This is early preview access to the META page. Some features may not work as expected"
                      }
                      PopperProps={{
                        style: { zIndex: 999999 },
                      }}
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#fff",
                            color: "#142C44CC",
                            fontSize: "12px",
                            fontWeight: "400",
                            padding: "8px 12px",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                            "& .MuiTooltip-arrow": {
                              color: "#fff",
                            },
                          },
                        },
                      }}
                    >
                      <span className={styles.betaTag}>Beta</span>
                    </Tooltip>
                  </div>
                )} */}

                <div className={styles.integrationItemTop}>
                  <div className={styles.integrationItemTopLogo}>
                    <img
                      src={item?.logo}
                      alt="logo"
                      style={{ maxWidth: "100%" }}
                    />
                  </div>
                  {item?.name === "Meta" && metaApp?.isCreditExhausted && (
                    <div>
                      <Tooltip
                        arrow
                        title={"You have exhausted your monthly credit limit"}
                        PopperProps={{
                          style: { zIndex: 999999 },
                        }}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#fff",
                              color: "#142C44CC",
                              fontSize: "12px",
                              fontWeight: "400",
                              padding: "8px 12px",
                              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                              "& .MuiTooltip-arrow": {
                                color: "#fff",
                              },
                            },
                          },
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img src={redIicon} alt="helpIcon" />
                        </span>
                      </Tooltip>
                    </div>
                  )}
                </div>

                <div className={styles.integrationItemHead}>
                  {item?.name}
                  {/* {item?.name === "Meta" && (
                    <span className={styles.betaTag}>Beta</span>
                  )} */}
                </div>
                <div className={styles.integrationItemDescription}>
                  {item?.description}
                </div>
                <Button
                  variant="contained"
                  sx={{ textTransform: "capitalize", minWidth: "110px" }}
                  onClick={() => {
                    navigate(`${item?.btnUrl}`);
                    if (
                      hasEdufin === false &&
                      item?.name === "Educational Loans"
                    ) {
                      dispatch<any>(
                        connectEdufin({
                          appName: "EDUFIN_LOAN",
                          appCode: "EDUFIN_LOAN",
                          instituteId: instituteDetails?.id,
                          createdById: authUser?.institute?.[0]?.id,
                          createdByName:
                            authUser?.firstName + " " + authUser?.lastName,
                          updatedById: "",
                          updatedByName: "",
                        })
                      );
                    }
                    localStorage.setItem("instituteData", "");
                    localStorage.setItem("idForEdufinForm", "");
                  }}
                  disabled={
                    getAccessStatus(
                      "INTEGRATIONS",
                      "ALL_ACCESS",
                      userById?.rolePermission
                    ) === false ||
                    (item?.name === "Ozonetel" && hasVoxbay) ||
                    (item?.name === "VoxBay" && hasOzonetel)
                      ? true
                      : false
                  }
                >
                  {item?.name === "Nurture Pay" &&
                  (nurturePayApp?.status === "UNDER_REVIEW" ||
                    nurturePayApp?.status === "SUBMITTED_FOR_KYC" ||
                    nurturePayApp?.status === "ACTIVE")
                    ? "View"
                    : item?.btnText}
                </Button>
              </div>
            ))}
          </div>
        </Box>
      </Box>
    </Box>
  );
}
